import { toast } from "react-toastify";
import { instance } from "./api";

const url = process.env.REACT_APP_BASE_URL || "/";

async function getWorkshopList(page,limit,filter,companyId) {
    // call the api for get workshop list

    const api = url + `/companies/${companyId}/workshops?page=${page}&filter=${filter}&limit=${limit}`;
    return await instance
    .get(api)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error.response;
    });
}

async function getWorkshopParticipantList(page,limit,filter,status,companyId,workshopId) {
  // call the api for get workshop Participants list

  const api = url + `/companies/${companyId}/workshops/${workshopId}/participants?page=${page}&filter=${encodeURIComponent(filter ?? "")}&limit=${limit}&status=${encodeURIComponent(status ?? "")}`;
  return await instance
  .get(api)
  .then((response) => {
    return response;
  })
  .catch((error) => {
    return error.response;
  });
}

async function getWorkshopDetails(companyId,workshopId) {
  // call the api for get workshop Details

  const api = url + `/companies/${companyId}/workshops/${workshopId}/details`;
  return await instance
  .get(api)
  .then((response) => {
    return response;
  })
  .catch((error) => {
    return error.response;
  });
}

const head={
  responseType: 'blob',
 }
async function getWorkshopParticipantDownload(companyId,workshopId) {
  // call the api for get workshopParticipant list Download

  const api = url + `/companies/${companyId}/workshops/${workshopId}/participants/download`;
  return await instance
  .get(api,head)
  .then((response) => {
    return response;
  })
  .catch((error) => {
    return error?.response;
  });
}

async function deleteWorkshopParticipant(
  companyId,
  workshopId,
  participant_ids
) {
  // call the api for delete workshop Participants

  const api =
    url + `/companies/${companyId}/workshops/${workshopId}/participants/delete`;
  return await instance
    .delete(api, { data: { participant_ids: participant_ids } })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error.response?.data;
    });
}

async function updateWorkshopDetails(companyId,workshopId,updatedDtata) {
  // call the api for update workshop Details

  const api = url + `/companies/${companyId}/workshops/${workshopId}/edit`;
  return await instance
  .put(api,updatedDtata)
  .then((response) => {
    return response;
  })
  .catch((error) => {
    return error.response?.data;
  });
}

async function updateWorkshopDetailsSecretariate(companyId,workshopId,updatedDtata) {
  // call the api for update secreteriate workshop Details

  const api = url + `/companies/${companyId}/workshops/${workshopId}/name`;
  return await instance
  .put(api,updatedDtata)
  .then((response) => {
    return response;
  })
  .catch((error) => {
    return error.response?.data;
  });
}
async function getWorkshopTemplate(companyId,workshopId,t) {
  // call the api for get workshopParticipant list Download

  const api = url + `/companies/${companyId}/workshops/${workshopId}/holdinginfo-template`;
  return await instance
  .get(api)
  .then((response) => {
    return response;
  })
  .catch((error) => {
    if (error?.response?.data?.error?.error_code) {
      toast.error(t(error?.response?.data?.error?.error_code), {
        toastId: 3,
      });
    } else {
      toast.error(
        t(error?.response?.data?.error?.details[0]?.errors[0]?.error_code),
        {
          toastId: 3,
        }
      );
    }
  });
}

async function getWorkshopInventoriesList(page,limit,filter,companyId,workshopId) {
  // call the api for get workshop Participants list

  const api = url + `/companies/${companyId}/workshops/${workshopId}/inventories?page=${page}&filter=${encodeURIComponent(filter ?? "")}&limit=${limit}`;
  return await instance
  .get(api)
  .then((response) => {
    return response;
  })
  .catch((error) => {
    return error.response;
  });
}

async function addInventoryDetails(company_id, workshop_id, data) {
  // call the api for add participant details

  const api =
    url +
    `/companies/${company_id}/workshops/${workshop_id}/inventories/add`;

  return await instance
    .post(api, data)
    .then((response) => {
      //retun status 1 for success
      return response;
    })
    .catch((error) => {
      //return error
      return error.response?.data;
    });
}
async function updateInventoryDetails(company_id, workshop_id,inventory_id, data) {
  // call the api for add participant details

  const api =
    url +
    `/companies/${company_id}/workshops/${workshop_id}/inventories/${inventory_id}`;

  return await instance
    .put(api, data)
    .then((response) => {
      //retun status 1 for success
      return response;
    })
    .catch((error) => {
      //return error
      return error.response?.data;
    });
}

async function getInventoryResponseList(page,limit,filter,status,companyId,workshopId,inventoryId) {
  // call the api for get workshop Participants list

  const api = url + `/companies/${companyId}/workshops/${workshopId}/inventories/${inventoryId}/responses?page=${page}&filter=${encodeURIComponent(filter ?? "")}&limit=${limit}&status=${encodeURIComponent(status ?? "")}`;
  return await instance
  .get(api)
  .then((response) => {
    return response;
  })
  .catch((error) => {
    return error.response;
  });
}

async function DownloadInventoryResponseList(companyId,workshopId,inventoryId, t) {

  const api = url + `/companies/${companyId}/workshops/${workshopId}/inventories/${inventoryId}/responses/download`;

  return await instance
    .get(api, {})
    .then((response) => {
      return response;
    })
    .catch((error) => {
      //show toast message
      if (error?.response?.data?.error?.error_code) {
        toast.error(t(error?.response?.data?.error?.error_code), {
          toastId: 3,
        });
      }
    })
  }

async function getEvaluationResponseList(page,limit,filter,status,companyId,workshopId) {
  // call the api for get workshop Participants list

  const api = url + `/companies/${companyId}/workshops/${workshopId}/evaluation_responses?page=${page}&filter=${encodeURIComponent(filter ?? "")}&limit=${limit}&status=${encodeURIComponent(status ?? "")}`;
  return await instance
  .get(api)
  .then((response) => {
    return response;
  })
  .catch((error) => {
    return error.response;
  });
}

async function updateEvaluationDetails(company_id, workshop_id, data) {
  // call the api for add participant details

  const api =
    url +
    `/companies/${company_id}/workshops/${workshop_id}/evaluation`;

  return await instance
    .put(api, data)
    .then((response) => {
      //retun status 1 for success
      return response;
    })
    .catch((error) => {
      //return error
      return error.response?.data;
    });
}

async function getWorkshopFollowUpsList(page,limit,filter,companyId,workshopId) {
  // call the api for get workshop Participants list

  const api = url + `/companies/${companyId}/workshops/${workshopId}/followups?page=${page}&filter=${encodeURIComponent(filter ?? "")}&limit=${limit}`;
  return await instance
  .get(api)
  .then((response) => {
    return response;
  })
  .catch((error) => {
    return error.response;
  });
}

async function addFollowUpDetails(company_id, workshop_id, data) {

  const api =
    url +
    `/companies/${company_id}/workshops/${workshop_id}/followups/add`;

  return await instance
    .post(api, data)
    .then((response) => {
      //retun status 1 for success
      return response;
    })
    .catch((error) => {
      //return error
      return error.response?.data;
    });
}

async function updateFollowUpDetails(company_id, workshop_id,followup_id, data) {

  const api =
    url +
    `/companies/${company_id}/workshops/${workshop_id}/followups/${followup_id}`;

  return await instance
    .put(api, data)
    .then((response) => {
      //retun status 1 for success
      return response;
    })
    .catch((error) => {
      //return error
      return error.response?.data;
    });
}

async function getFollowupResponseList(page,limit,filter,status,companyId,workshopId,followupId) {

  const api = url + `/companies/${companyId}/workshops/${workshopId}/followups/${followupId}/responses?page=${page}&filter=${encodeURIComponent(filter ?? "")}&limit=${limit}&status=${encodeURIComponent(status ?? "")}`;
  return await instance
  .get(api)
  .then((response) => {
    return response;
  })
  .catch((error) => {
    return error.response;
  });
}

async function DownloadEvaluationResponseList(companyId,workshopId, t) {

  const api = url + `/companies/${companyId}/workshops/${workshopId}/responses/download`;

  return await instance
    .get(api, {})
    .then((response) => {
      return response;
    })
    .catch((error) => {
      //show toast message
      if (error?.response?.data?.error?.error_code) {
        toast.error(t(error?.response?.data?.error?.error_code), {
          toastId: 3,
        });
      }
    })
  }

async function DownloadFollowupResponseList(companyId,workshopId,followupId, t) {

    const api = url + `/companies/${companyId}/workshops/${workshopId}/followups/${followupId}/responses/download`;
  
    return await instance
      .get(api, {})
      .then((response) => {
        return response;
      })
      .catch((error) => {
        //show toast message
        if (error?.response?.data?.error?.error_code) {
          toast.error(t(error?.response?.data?.error?.error_code), {
            toastId: 3,
          });
        }
      })
    }

async function getTaskSettings(company_id, workshop_id) {
      // call the api for add participant details
    
      const api =
        url +
        `/companies/${company_id}/workshops/${workshop_id}/tasks`;
    
      return await instance
        .get(api)
        .then((response) => {
          //retun status 1 for success
          return response;
        })
        .catch((error) => {
          //return error
          return error.response;
        });
    }

async function sendEmailWorkshopParticipant(
      companyId,
      workshopId,
      participant_ids
    ) {
      
      const api =
        url + `/companies/${companyId}/workshops/${workshopId}/send-reminder`;
      return await instance
        .post(api,  { participants: participant_ids } )
        .then((response) => {
          return response;
        })
        .catch((error) => {
          return error.response?.data;
        });
    }

async function sendEmailInventoryParticipant(
      companyId,
      workshopId,
      inventoryId,
      participant_ids
    ) {
      
      const api =
        url + `/companies/${companyId}/workshops/${workshopId}/inventories/${inventoryId}/send-reminder`;
      return await instance
        .post(api,  { participants: participant_ids } )
        .then((response) => {
          return response;
        })
        .catch((error) => {
          return error.response?.data;
        });
    }

async function sendEmailEvaluationParticipant(
      companyId,
      workshopId,
      participant_ids
    ) {
      
      const api =
        url + `/companies/${companyId}/workshops/${workshopId}/send-evaluation-reminder`;
      return await instance
        .post(api,  { participants: participant_ids } )
        .then((response) => {
          return response;
        })
        .catch((error) => {
          return error.response?.data;
        });
    }

async function sendEmailFollowupParticipant(
      companyId,
      workshopId,
      followupId,
      participant_ids
    ) {
      
      const api =
        url + `/companies/${companyId}/workshops/${workshopId}/followups/${followupId}/send-reminder`;
      return await instance
        .post(api,  { participants: participant_ids } )
        .then((response) => {
          return response;
        })
        .catch((error) => {
          return error.response?.data;
        });
    }


async function getFollowupMailTemplate(companyId,workshopId,t) {
      // call the api for get followup mail template
    
      const api = url + `/companies/${companyId}/workshops/${workshopId}/followups/implementation-guide-template`;
      return await instance
      .get(api)
      .then((response) => {
        return response;
      })
      .catch((error) => {
        if (error?.response?.data?.error?.error_code) {
          toast.error(t(error?.response?.data?.error?.error_code), {
            toastId: 3,
          });
        } else {
          toast.error(
            t(error?.response?.data?.error?.details[0]?.errors[0]?.error_code),
            {
              toastId: 3,
            }
          );
        }
      });
    }

export const workshopService = {
    getWorkshopList,
    getWorkshopParticipantList,
    getWorkshopDetails,
    getWorkshopParticipantDownload,
    deleteWorkshopParticipant,
    updateWorkshopDetails,
    updateWorkshopDetailsSecretariate,
    getWorkshopTemplate,
    getWorkshopInventoriesList,
    addInventoryDetails,
    updateInventoryDetails,
    getInventoryResponseList,
    DownloadInventoryResponseList,
    getEvaluationResponseList,
    updateEvaluationDetails,
    getWorkshopFollowUpsList,
    addFollowUpDetails,
    updateFollowUpDetails,
    getFollowupResponseList,
    DownloadEvaluationResponseList,
    DownloadFollowupResponseList,
    getTaskSettings,
    sendEmailWorkshopParticipant,
    sendEmailInventoryParticipant,
    sendEmailEvaluationParticipant,
    sendEmailFollowupParticipant,
    getFollowupMailTemplate
  };
